import React, { useEffect, useMemo, useState } from 'react';

import { sameOriginApiBase } from '../../util/sameOriginApiBase';

const lookupCache = new Map();

const clean = value => String(value || '').trim();

export const cityDisplayNameFromPublicData = publicData => {
  const loc = publicData?.location || {};
  const city = clean(publicData?.venueCity) || clean(loc.city) || clean(loc.addressLocality);
  const state = clean(publicData?.venueState) || clean(loc.state) || clean(loc.addressRegion);
  if (!city) {
    return null;
  }
  return [city, state].filter(Boolean).join(', ');
};

const cityLookupParams = publicData => {
  const loc = publicData?.location || {};
  const city = clean(publicData?.venueCity) || clean(loc.city) || clean(loc.addressLocality);
  const state = clean(publicData?.venueState) || clean(loc.state) || clean(loc.addressRegion);
  if (!city) {
    return null;
  }
  return {
    city,
    ...(state ? { state } : {}),
  };
};

const SeoCityLinkMaybe = ({ publicData, className, children }) => {
  const fallbackText = children || cityDisplayNameFromPublicData(publicData);
  const params = useMemo(() => cityLookupParams(publicData), [publicData]);
  const cacheKey = params ? JSON.stringify(params) : null;
  const [path, setPath] = useState(() => (cacheKey ? lookupCache.get(cacheKey) || null : null));

  useEffect(() => {
    if (!cacheKey || lookupCache.has(cacheKey) || typeof fetch !== 'function') {
      return;
    }
    const base = sameOriginApiBase();
    if (!base) {
      return;
    }

    let cancelled = false;
    const query = new URLSearchParams(params).toString();
    fetch(`${base}/api/seo-discovery/city-link?${query}`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(res => (res.ok ? res.json() : { found: false }))
      .then(body => {
        const nextPath = body?.found ? body.path : null;
        lookupCache.set(cacheKey, nextPath);
        if (!cancelled) {
          setPath(nextPath);
        }
      })
      .catch(() => {
        lookupCache.set(cacheKey, null);
      });

    return () => {
      cancelled = true;
    };
  }, [cacheKey, params]);

  if (!fallbackText) {
    return null;
  }

  return path ? (
    <a className={className} href={path}>
      {fallbackText}
    </a>
  ) : (
    <span className={className}>{fallbackText}</span>
  );
};

export default SeoCityLinkMaybe;
